<template>
    <teleport to="body">
        <Transition name="popup-slide">
            <div v-if="showPopup" class="">
                <div class="flex items-center w-100% vip-tab justify-between fixed top-35px z-1000 color-#fff">
                    <div class="flex items-center justify-center vip-tab-content">
                        <!-- <div class="vip-tab-content-item" :class="{ 'tab-content-active-vip': activeTab === 0 }"
                            @click="handleTabClick(0)">vip</div> -->
                        <!-- <div class="vip-tab-content-item" :class="{ 'tab-content-active-svip': activeTab === 1 }"
                            @click="handleTabClick(1)">svip</div> -->

                        <div class="absolute top-5px right-10px w-24px h-24px z-100" @click="showSurePopup = true">
                            <img src="@/assets/images/home/close.webp" alt="" class="w-full h-full">
                        </div>
                    </div>
                </div>
                <div class="vip" v-if="activeTab === 0">
                    <div class="fixed top-0 right-0 z-999 w-100% h-100% popup-overlay"
                        @click.self="showSurePopup = true">
                        <div class="popup-container" :class="{ 'popup-show': showPopup }">
                            <div class="relative w-100% h-15%">
                                <div class="">
                                    <img src="@/assets/images/home/bg_popup.webp" alt="" class="w-full h-full">
                                </div>
                            </div>
                            <div class="bg-#18103B h-100% pt-150px">
                                <div class="text-vip"
                                    v-if="![3, 4].includes(userInfo?.role) && storePageStore.rechargeItems[0]?.list[0]?.limitBuy === 1 && storePageStore.rechargeItems.length > 0">
                                    {{ t('firstCharge.title') }}
                                </div>
                                <!-- <div v-else class="text-vip">
                                    Lifetime VIP
                                </div> -->
                                <!-- <div class="color-#fff text-center text-14px">
                                    VIP Membership Benefits    
                                </div> -->
                                <!-- <div class="countdown-container flex items-center justify-center mt-15px"
                                    v-if="isLimitBuy">
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.hours) }}</span>
                                    </div>
                                    <span class="countdown-separator">:</span>
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.minutes) }}</span>
                                    </div>
                                    <span class="countdown-separator">:</span>
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.seconds) }}</span>
                                    </div>
                                </div> -->
                                <div class="p-20px pb-0! h-300px overflow-y-auto">
                                    <div v-for="value in benefitList"
                                        class="flex items-center justify-between benefit-item">
                                        <div class="flex">
                                            <div class="flex items-center justify-center mr-10px">
                                                <img src="@/assets/images/home/dian.webp" alt=""
                                                    class="w-12px h-12px"></img>
                                            </div>
                                            <div class="color-#fff">{{ value }}</div>
                                        </div>
                                        <div class="text-vip text-12px!" v-if="isLimitBuy">
                                            Get
                                        </div>
                                        <div v-else>
                                            <img src="@/assets/images/store/dui.webp" alt=""
                                                class="w-12px h-12px"></img>

                                        </div>
                                    </div>
                                </div>
                                <div class="countdown-container flex items-center justify-center mt-15px"
                                    v-if="isLimitBuy">
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.hours) }}</span>
                                    </div>
                                    <span class="countdown-separator">:</span>
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.minutes) }}</span>
                                    </div>
                                    <span class="countdown-separator">:</span>
                                    <div class="countdown-box">
                                        <span class="countdown-number">{{ formatTime(countdown.seconds) }}</span>
                                    </div>
                                </div>
                                <div class="flex items-center relative justify-center popup-btn"
                                    @click="handleFirstCharge()" v-if="isLimitBuy">
                                    <div class=" w-102px absolute left-0 top--10px">
                                        <img src="@/assets/images/other/first_btn.svg" alt=""
                                            class="w-full h-full"></img>
                                        <div class="absolute left-5px top-5px text-9px color-#fff">
                                            {{ t('firstCharge.limitedOffer') }}
                                        </div>
                                    </div>
                                    <span>
                                        ${{ displayPrice.original }}
                                    </span>
                                    {{ t('firstCharge.priceFormat', { price: displayPrice.current }) }}
                                </div>
                                <div v-else class="buy-suss">
                                    <img src="@/assets/images/store/buy_success.webp" alt="" class="w-24px h-24px">
                                    <div class="color-#fff text-center text-14px font-500">
                                        {{ t('firstCharge.congratulations') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
        <Transition name="confirm-popup">
            <div v-if="showSurePopup" class="confirm-popup p-15px">
                <!-- <div class="text-center text-14px font-800 confirm-title">
                    {{ t('firstCharge.missOfferTitle') }} <br>
                    VIP members' privileges are ready for you!
                </div> -->
                <div class="flex items-center justify-center mt-13px">
                    <div class="flex items-center justify-center text-12px font-500 w-90px h-77px vip-icon-wrapper">
                        <img src="@/assets/images/home/vip_icon.webp" alt="" class="w-100% h-100% vip-icon">
                    </div>
                </div>
                <div class="color-#000 text-center text-14px font-500 mt-10px confirm-subtitle">
                    {{ t('firstCharge.missOfferTitle') }}
                </div>
                <div class="confirm-popup-text text-center text-20px font-800 confirm-price">
                    Save <span class="text-28px font-800">75%</span> or <span class="text-28px font-800">${{
                        displayPrice.original - displayPrice.current }}</span>
                </div>
                <div
                    class="w-100% mt-22px flex gap-10px items-center justify-center text-center text-12px font-500 confirm-buttons">
                    <div class="anyway-btn" @click="handleClosePopup">
                        {{ t('firstCharge.maybeLater') }}
                    </div>
                    <div class="activate-btn" @click="handleFirstCharge">
                        {{ t('firstCharge.getNow') }}
                    </div>
                </div>
            </div>
        </Transition>
    </teleport>
</template>

<script setup lang="ts">
import { logEventSafe } from "@/plugins/firebase";
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useStorePageStore } from '@/stores/store'
import bridge from '@/utils/bridge'
import { getH5Payment } from '@/views/store/index'
import { deviceStorage } from '@/utils/storage';
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'
const { t } = useI18n()

const router = useRouter()
const randomStore = useRandomArrayStore()

const emit = defineEmits(['update:showPopup'])
const props = defineProps({
    showPopup: {
        type: Boolean,
        default: false
    },
    url: {
        type: String,
        default: '/store'
    }
})

const benefitList = computed(() => [
    t('firstCharge.benefit1'),
    t('firstCharge.benefit2'),
    t('firstCharge.benefit3'),
    t('firstCharge.benefit4'),
    t('firstCharge.benefit5'),
])

const userStore = useUserStore()
const storePageStore = useStorePageStore()
const userInfo = computed(() => userStore.getTouristInfo())
const activeTab = ref(0)
const activeIndex = ref(0)
const showSurePopup = ref(false)
const isLimitBuy = computed(() => {
    if (![3, 4].includes(userInfo.value?.role)) {
        return true
    } else {
        if (storePageStore.rechargeItems[0]?.list[0]?.limitBuy === 1 && storePageStore.rechargeItems.length > 0) {
            return true
        } else {
            return false
        }
    }
}

)


const isEmbeddedH5 = computed(() => userStore.getIsEmbeddedH5())


const storeItems = computed(() => {
    return storePageStore.rechargeItems?.[0]?.list?.[0] || null
})

const displayPrice = computed(() => {
    if (!storeItems.value) return { original: 0, current: 0 }
    return {
        original: storeItems.value.originalPrice ? storeItems.value.originalPrice / 100 : 0,
        current: storeItems.value.price ? storeItems.value.price / 100 : 0
    }
})



const handleClosePopup = () => {
    showSurePopup.value = false
    emit('update:showPopup', false)
}

const handleFirstCharge = async () => {
    bridge.call(randomStore.randomArray[1], {
        item: storeItems.value,
        url: '/applePurchase'
    })
    // localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    // if (isEmbeddedH5.value) {
    //     bridge.call(randomStore.randomArray[1], {
    //         item: storeItems.value,
    //         url: '/applePurchase'
    //     })
    // } else {
    //     // H5 支付
    //     await getH5Payment(storeItems.value, 0, userInfo.value, deviceStorage)
    // }
    // if (localStorage.getItem('first_pay_success_to_vippage') !== '1') {
    //     logEventSafe('first_pay_success_to_vippage');
    // }
}

// 倒计时相关
const countdown = ref({
    hours: 24,
    minutes: 0,
    seconds: 0
})

let countdownTimer: number | null = null

const formatTime = (time: number): string => {
    return time.toString().padStart(2, '0')
}

const startCountdown = () => {
    // 检查是否有存储的结束时间
    const endTimeKey = 'vip_countdown_end_time'
    let endTime = localStorage.getItem(endTimeKey)

    if (!endTime) {
        // 如果没有存储的结束时间，设置24小时后
        const now = new Date().getTime()
        const end = now + 24 * 60 * 60 * 1000 // 24小时
        endTime = end.toString()
        localStorage.setItem(endTimeKey, endTime)
    }

    const updateCountdown = () => {
        const now = new Date().getTime()
        const end = parseInt(endTime || '0')
        const diff = end - now

        if (diff <= 0) {
            // 倒计时结束，重新开始24小时倒计时
            const newEnd = now + 24 * 60 * 60 * 1000
            localStorage.setItem(endTimeKey, newEnd.toString())
            countdown.value = {
                hours: 24,
                minutes: 0,
                seconds: 0
            }
            return
        }

        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        countdown.value = {
            hours,
            minutes,
            seconds
        }
    }

    updateCountdown()
    countdownTimer = window.setInterval(updateCountdown, 1000)
}

// 监听弹窗显示状态，启动或停止倒计时
watch(() => props.showPopup, (newVal) => {
    if (newVal && isLimitBuy.value) {
        startCountdown()
    } else {
        if (countdownTimer) {
            clearInterval(countdownTimer)
            countdownTimer = null
        }
    }
}, { immediate: true })

onUnmounted(() => {
    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
})


window.addEventListener(randomStore.randomArray[0], function () {
    showSurePopup.value = false
});



</script>

<style scoped lang="scss">
:deep(.van-popup) {
    background: transparent;
    overflow: visible;
}



.popup-content {
    padding-top: 100px;
    width: 316px;
    height: 316px;
    background-image: url('@/assets/images/other/background-first.webp');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    .top-up {
        position: relative;
        width: 120px;
        height: 52px;
        border-radius: 8px;
        border: 1px solid transparent;
        background:
            linear-gradient(180deg, #7058F8 0%, #301665 100%) padding-box,
            linear-gradient(180deg, rgba(255, 255, 255, 0.26), rgba(255, 255, 255, 0.37)) border-box;

        .top-up-text {
            position: absolute;
            top: -10px;
            right: 0;
            width: 48px;
            height: 16px;
            background: #433C7E;
            border-radius: 3px;
            font-weight: 600;
            font-size: 10px;
            color: #FFFFFF;
            line-height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .extra {
        width: 120px;
        height: 52px;
        border-radius: 8px;
        border: 1px solid transparent;
        position: relative;
        background:
            linear-gradient(180deg, #9965F1 0%, #421A65 100%) padding-box,
            linear-gradient(180deg, rgba(255, 255, 255, 0.26), rgba(255, 255, 255, 0.37)) border-box;

        .extra-text {
            position: absolute;
            top: -10px;
            right: 0;
            width: 48px;
            height: 16px;
            // background: #433C7E;
            background: linear-gradient(180deg, #FE80E3 0%, #FDB9BE 100%);
            border-radius: 3px;
            font-weight: 600;
            font-size: 10px;
            color: #FFFFFF;
            line-height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.app-first-charge {
    position: fixed;
    right: 0;
    bottom: 20%;
    z-index: 99;
}

.btn {
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('@/assets/images/other/button-bg.webp');
    font-weight: 900;
    font-size: 10px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-btn {
    margin: auto;
    // z-index: 99;
    // transform: translateX(-50%);
    background: linear-gradient(90deg, #A06EFA 0%, #FA6CCE 100%);
    box-shadow: inset 0px 0px 10px 0px rgba(112, 57, 203, 0.5);
    width: 220px;
    height: 50px;
    border-radius: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
    margin-top: 20px;

    span {
        text-decoration-line: line-through;
        font-size: 10px;
        color: #FFFFFF;
        margin-right: 5px;
    }
}

.text-vip {
    background: linear-gradient(0deg, #3733F2 0%, #FAC3EC 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-weight: 800;
    font-size: 24px;
    text-align: center;
    font-style: italic;
}

.benefit-item {
    position: relative;
    padding: 11px 21px;
    margin-bottom: 10px;
    border-radius: 10px;
    background: linear-gradient(90deg, rgba(55, 51, 242, 1), rgba(250, 195, 236, 1), rgba(55, 51, 242, 1));

    // 内容区域
    &::before {
        content: '';
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        background: #18103B;
        border-radius: 10px;
        z-index: 0;
    }

    // 确保内容在上层
    >div {
        position: relative;
        z-index: 1;
    }
}

// 倒计时样式
.countdown-container {
    gap: 2px;
}

.countdown-box {
    min-width: 18px;
    width: 18px;
    height: 18px;
    background: linear-gradient(180deg, #FFE6F9 0%, #F8A5E4 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
}

.countdown-number {
    font-size: 11px;
    font-weight: 500;
    // color: #EF6BFF;
    color: #A006C2;
    // text-shadow: 0 0 10px rgba(239, 107, 255, 0.5);
    // letter-spacing: 1px;
}

.countdown-separator {
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    // text-shadow: 0 0 10px rgba(239, 107, 255, 0.5);
    margin: 0 4px;
}

// 弹窗动画
.popup-overlay {
    overflow: hidden;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    perspective: 1200px;
    transform-style: preserve-3d;
}

.popup-container {
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transform-origin: center center;
    transform: rotateY(-90deg) scale(0.8);
    opacity: 0;
    transition: transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.7s ease;

    &.popup-show {
        transform: rotateY(0deg) scale(1);
        opacity: 1;
        animation: container-flip-in 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
}

// 弹窗整体翻转动画
:deep(.popup-slide-enter-active) .popup-overlay {
    animation: overlay-fade-in 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

:deep(.popup-slide-enter-active) .popup-container {
    animation: container-flip-in 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
}

:deep(.popup-slide-leave-active) .popup-overlay {
    animation: overlay-fade-out 0.4s cubic-bezier(0.55, 0.06, 0.68, 0.19);
}

:deep(.popup-slide-leave-active) .popup-container {
    animation: container-flip-out 0.4s cubic-bezier(0.6, 0, 0.8, 0.2);
}

:deep(.popup-slide-enter-from) .popup-overlay {
    opacity: 0;
    backdrop-filter: blur(0);
    -webkit-backdrop-filter: blur(0);
}

:deep(.popup-slide-enter-from) .popup-container {
    transform: rotateY(-90deg) scale(0.8);
    opacity: 0;
}

:deep(.popup-slide-leave-to) .popup-overlay {
    opacity: 0;
    backdrop-filter: blur(0);
    -webkit-backdrop-filter: blur(0);
}

:deep(.popup-slide-leave-to) .popup-container {
    transform: rotateY(90deg) scale(0.8);
    opacity: 0;
}

@keyframes overlay-fade-in {
    0% {
        opacity: 0;
        -webkit-backdrop-filter: blur(0);
        backdrop-filter: blur(0);
    }

    100% {
        opacity: 1;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }
}

@keyframes overlay-fade-out {
    0% {
        opacity: 1;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }

    100% {
        opacity: 0;
        backdrop-filter: blur(0);
        -webkit-backdrop-filter: blur(0);
    }
}

@keyframes container-flip-in {
    0% {
        transform: rotateY(-90deg) scale(0.8);
        opacity: 0;
    }

    50% {
        transform: rotateY(10deg) scale(1.05);
        opacity: 0.8;
    }

    100% {
        transform: rotateY(0deg) scale(1);
        opacity: 1;
    }
}

@keyframes container-flip-out {
    0% {
        transform: rotateY(0deg) scale(1);
        opacity: 1;
    }

    100% {
        transform: rotateY(90deg) scale(0.8);
        opacity: 0;
    }
}

.buy-suss {
    margin: auto;
    background-image: url('@/assets/images/store/buy_success.webp');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    width: 317px;
    height: 50px;
    border-radius: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.vip-tab {
    border-radius: 14px;
    // transform: translateX(-50%);
    justify-content: center;

    .vip-tab-content {
        // gap: 10px;
        background: rgba(255, 255, 255, 0.1);
        // padding: 2px 0px;
        border-radius: 14px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;

        .vip-tab-content-item {
            width: 60px;
            height: 24px;
            // background: rgba(255, 255, 255, 0.1);
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .tab-content-active-vip {
            background: linear-gradient(90deg, #A06EFA 0%, #FA6CCE 100%);
            color: #FFFFFF;
        }

        .tab-content-active-svip {
            background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
            color: #854A0D;
            width: 60px;
            height: 24px;
            background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

    }

}

.svip {
    .text-vip {

        background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);

        // background: linear-gradient(0deg, #3733F2 0%, #FAC3EC 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        font-weight: 800;
        font-size: 24px;
        text-align: center;
        font-style: italic;
    }

    .members-privilege {
        border-radius: 15px;
        border: 1px solid rgba(221, 184, 138, 1);
        // border-image: linear-gradient(180deg, rgba(181, 173, 161, 1), rgba(221, 184, 138, 1)) 1 1;
    }
}

.svip-benefit-list {
    border-radius: 15px;
    width: 90px;
    background: rgba(67, 58, 73, 1);
}

.svip-benefit-bottom {
    // padding: 0px 20px;
    width: 100%;
    // background: rgba(67, 58, 73, 1);
    // height: 200px;
    // border-radius: 15px;
    overflow-x: auto;
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;


    .svip-benefit-bottom-item {
        border: 2px solid transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        width: 148px;
        padding: 11px 0px;
        flex-shrink: 0;
        background: #3B3433;
        border-radius: 15px;
        color: #FFFFFF;
        background: rgba(67, 58, 73, 1);
        border-radius: 15px;
        height: 70px;

        &.active {
            background: linear-gradient(90deg, #1A1114 0%, #684135 100%) !important;
            // border-radius: 15px;
            border: 2px solid rgba(255, 223, 179, 1);
        }
    }
}

.bottom-content {
    box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.5);
    background: #19100F;

}

.bottom-btn {
    margin-top: 20px;
    background: linear-gradient(180deg, rgba(25, 16, 15, 0) 0%, #19100F 100%);
    padding: 10px 0px;
    border-radius: 15px;
    background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
    border-radius: 35px;
    font-weight: 800;
    font-size: 15px;
    color: #854A0D;
}

.confirm-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 335px;
    height: 254px;
    background: linear-gradient(180deg, #FFE6F4 0%, #FFFFFF 100%);
    border-radius: 20px;
    z-index: 9999;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

    .confirm-title {
        animation: fade-in-up 0.3s ease-out 0.05s both;
    }

    .vip-icon-wrapper {
        animation: fade-in-scale 0.3s ease-out 0.15s both;
    }

    .vip-icon {
        animation: pulse-rotate 2s ease-in-out infinite;
    }

    .confirm-subtitle {
        animation: fade-in-up 0.3s ease-out 0.25s both;
    }

    .confirm-price {
        font-style: italic;
        font-weight: 800;
        background: linear-gradient(180deg, #FFC2EF 0%, #C137FF 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        animation: fade-in-scale 0.3s ease-out 0.35s both;
    }

    .confirm-buttons {
        animation: fade-in-up 0.3s ease-out 0.45s both;
    }

    .anyway-btn {
        flex: 1;
        background: rgba(1, 3, 27, 0.1);
        font-size: 14px;
        // color: #01031B;
        color: rgba(1, 3, 27, 0.5);
        border-radius: 23px;
        font-weight: 800;
        padding: 6px 18px;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
            background: rgba(1, 3, 27, 0.5);
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .activate-btn {
        flex: 1;
        font-size: 14px;
        font-weight: 800;
        color: #FFFFFF;
        border-radius: 23px;
        padding: 6px 18px;
        background: linear-gradient(90deg, #5A68FF 0%, #95A5FF 100%);
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.5s ease;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(90, 104, 255, 0.4);

            &::before {
                left: 100%;
            }
        }

        &:active {
            transform: translateY(0);
        }
    }
}

// 确认弹窗动画
.confirm-popup-enter-active {
    animation: confirm-popup-enter 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.confirm-popup-leave-active {
    animation: confirm-popup-leave 0.2s ease-in;
}

.confirm-popup-enter-from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
}

.confirm-popup-leave-to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
}

@keyframes confirm-popup-enter {
    0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8) rotateY(-10deg);
    }

    50% {
        transform: translate(-50%, -50%) scale(1.05) rotateY(5deg);
    }

    100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1) rotateY(0deg);
    }
}

@keyframes confirm-popup-leave {
    0% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }

    100% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.9);
    }
}

@keyframes fade-in-up {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fade-in-scale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes pulse-rotate {

    0%,
    100% {
        transform: scale(1) rotate(0deg);
    }

    25% {
        transform: scale(1.1) rotate(5deg);
    }

    50% {
        transform: scale(1) rotate(0deg);
    }

    75% {
        transform: scale(1.1) rotate(-5deg);
    }
}
</style>